import { useEffect, useRef } from 'react';

import { useReorderNavigation } from '../../../../hooks/useReorderNavigation';
import { useReorderState } from '../useReorderState';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Sends the customer home when a reorder screen opens with no reorder in progress, as after a
 * page reload or when a link to a reorder route is opened. Without a reorder, web renders those
 * screens empty, and their transparent modal would block the page.
 */
export const useDismissInactiveReorderRoute = () => {
  const { currentStep } = useReorderState();
  const { dismissReorderHome } = useReorderNavigation();

  // ─── Refs ──────────────────────────────────────────────────────────────────

  const hasOpenedWithoutReorderRef = useRef(currentStep === 'idle');

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!hasOpenedWithoutReorderRef.current) return;

    hasOpenedWithoutReorderRef.current = false;
    dismissReorderHome();
  }, [dismissReorderHome]);
};
